import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AchievementsSection } from '../components/AchievementsSection';
import { ServicesSection } from '../components/ServicesSection';
import { NichesSection } from '../components/NichesSection';
import { ProcessSteps } from '../components/ProcessSteps';
import { AdvantagesSection } from '../components/AdvantagesSection';
import { CeoSection } from '../components/CeoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-804">
      <Header data-id="element-805" />
      <main data-id="element-806">
        <HeroSection data-id="element-807" />
        <AchievementsSection data-id="element-808" />
        <ServicesSection data-id="element-809" />
        <NichesSection data-id="element-810" />
        <ProcessSteps data-id="element-811" />
        <AdvantagesSection data-id="element-812" />
        <CeoSection data-id="element-813" />
        <TestimonialsSection data-id="element-814" />
        <ContactForm data-id="element-815" />
      </main>
      <Footer data-id="element-816" />
    </div>;
}